// src/auth/AuthCallback.tsx
import { useEffect, useRef } from 'react';

import { messages } from '../../modules/translation';
import auth from '../auth';
import { notificationError } from '../toast';

export default function AuthCallback() {
  const ranRef = useRef(false);

  useEffect(() => {
    if (ranRef.current) return;
    ranRef.current = true;

    void auth.userManager
      .signinCallback()
      .then((user) => {
        console.log('signinCallback ok', user);
        window.location.replace((user?.state as string) || '/');
      })
      .catch((err) => {
        console.error('OIDC callback error:', err);
        notificationError('Access is not allowed for this application.');
        window.setTimeout(() => {
          void auth.logout();
        }, 3000);
      });
  }, []);

  return (
    <div className="d-flex align-items-center justify-content-center vh-100 bg-light">
      <div className="text-center p-4">
        <div className="spinner-border text-primary mb-3" role="status" aria-hidden="true" />
        <h5 className="text-muted mb-0">{messages('pleaseWait')}</h5>
      </div>
    </div>
  );
}
